import React from "react";
import { Container, Row, Col } from "react-grid-system";

// STYLES
import styled from "styled-components";

// SHARED
import { Section } from "../../shared/shared";

// COMPONENTS
import Title from "../../components/title/title.component";

export default class Benefits extends React.PureComponent {
  render() {
    let { t } = this.props;
    const benefitsData = [
      { title: t("BenefitsTopic1Title"), text: t("BenefitsTopic1Text") },
      { title: t("BenefitsTopic2Title"), text: t("BenefitsTopic2Text") },
      { title: t("BenefitsTopic3Title"), text: t("BenefitsTopic3Text") },
      { title: t("BenefitsTopic4Title"), text: t("BenefitsTopic4Text") },
      { title: t("BenefitsTopic5Title"), text: t("BenefitsTopic5Text") },
      { title: t("BenefitsTopic6Title"), text: t("BenefitsTopic6Text") },
      { title: t("BenefitsTopic7Title"), text: t("BenefitsTopic7Text") },
    ];
    return (
      <Section>
        <Container>
          <Row>
            <Col sm={12} className="center">
              <Title text={t("BenefitsTitle")} />
            </Col>

            {benefitsData.map((item, index) => (
              <Col key={index} md={6} sm={12}>
                <BenefitsTitle>{item.title}</BenefitsTitle>
                <BenefitsText>{item.text}</BenefitsText>
              </Col>
            ))}
          </Row>
        </Container>
        <Space></Space>
      </Section>
    );
  }
}

const BenefitsTitle = styled.h5`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
  min-height: 50px;
  margin-bottom: 10px;

  @media screen and (max-width: 767px) {
    text-align: center;
  }
`;
const BenefitsText = styled.p`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  color: #000000;
  font-size: 16px;

  @media screen and (max-width: 767px) {
    text-align: center;
  }
`;
const Space = styled.div`
  width: 100%;
  height: 120px;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/benefits/benefits.component.js